let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9AUAq")).then(() => parcelRequire('2BBdo'));